export default {
  name: "RequestForgotPasswordLink",
  path: "/forgot-password",
  component: () => import("@/views/ForgotPassword/RequestForgotPasswordLink")
};
